import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","padding-left":"10px"} }, " 百分比(%) ", -1)
const _hoisted_3 = { style: {"color":"red","padding-left":"10px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保 存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")

import { ref, reactive, unref, watch } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { propTypes } from '@/utils/propTypes';

import { deepClone } from '../../../utils/index';
import { GbDialog } from '@/components/GbDialog/Index';

/* Typtes */
import { PlanCreate } from '@/apis/PayPlans/payplan.type';
import { CipherAmountApi, GetPayplanConfigApi, CipherScalcApi } from '@/apis/contract/draft.api';


export default /*#__PURE__*/_defineComponent({
  props: {
	ctAmounts: propTypes.number.def(0),
	loading: propTypes.bool.def(false),
},
  emits: ['onAdd'],
  setup(__props, { expose, emit: $emit }) {

const $props = __props

const short = require('short-uuid');
const payPlanFormRef = ref<ComponentRef<typeof ElForm>>();

const editModel = ref<boolean>(false);
const setAmount = ref<number>(0);
const planSchema = ref<any>({ id: short.generate() });





/* 数值验证金额 */
const validateAmount = (rule: any, value: any, callback: any) => {
	const totalAmt = $props.ctAmounts - parseFloat((setAmount.value || 0) + '');

	if (!value || isNaN(value)) {
		callback(new Error('请输入数字'));
	}
	if (value <= 0) {
		callback(new Error('款项金额不能小于等于零'));
	} else if (value.toString().indexOf('.') !== -1 && value.toString().split('.')[1].length > 2) {
		callback(new Error('小数点后最多保留两位'));
	} else if (value > totalAmt) {
		callback(new Error(`款项金额已超出合同总额，当前已设置款项总金额：${setAmount.value}`));
	} else {
		callback();
	}
};

const state = reactive({
	showDialog: false,
	title: '付款计划编辑器',
	loading: false,
	disabledAmt: false,
	config: {} as any,
	rules: {
		name: [{ required: true, message: '款项名称不能为空', trigger: 'blur' }],
		pay_condition: [{ required: true, message: '款项条件不能为空', trigger: 'blur' }],
		amount: [{ required: true, message: '款项金额不能留空', trigger: 'blur' }, { validator: validateAmount }],
	} as FormRules,
});

const events = {
	onAmountChange: async (amount: any) => {
		if (($props.ctAmounts ?? 0) <= 0) return;

		const { data } = await CipherAmountApi($props.ctAmounts, amount);
		unref(planSchema).scale = data;
	},
	onScalceChange: async (scalc: any) => {
		if (($props.ctAmounts ?? 0) <= 0) return;
		const { data } = await CipherScalcApi($props.ctAmounts, scalc);
		unref(planSchema).amount = data;
	},
	onSave: () => {
		$emit('onAdd', unref(planSchema));
		state.showDialog = false;
	},
};

/* 暴露出去的属性 or 方法 */
const methods = {
	addPayPlan: async (ctAmount: number, planList: any[], paytype?: string) => {
		const { succeeded, errors, data } = await GetPayplanConfigApi(ctAmount, planList);
		if (!succeeded) {
			ElMessage.error(errors);
			return;
		}

		state.config = data || {};
		planSchema.value = { id: short.generate(), scale: data.maxScalc, amount: data.maxAmount };

		state.title = '添加付款计划';
		state.disabledAmt = paytype && paytype == 'Y' ? true : false;
		state.showDialog = true;
	},
	editPayplan: async (row: any) => {
		state.title = '修改付款计划';
		state.showDialog = true;
	},

	/* 保存数据 */
	// saveData: async (contractId: string, list: any[]): Promise<PlanAddRes> => {
	// 	let res: PlanAddRes = { isSuccess: false, data: list };
	// 	await unref(payPlanFormRef)?.validate((isValid: boolean) => {
	// 		if (!isValid) return res;
	// 		if (editModel.value) {
	// 			let index = list.findIndex((a) => a.id == planSchema.value.id);
	// 			if (index != -1) {
	// 				list[index] = Object.assign({}, list[index], planSchema.value);
	// 			}
	// 		} else {
	// 			const planItem = Object.assign({}, { revision: '0', contract_id: contractId }, planSchema.value);
	// 			list.push(planItem);
	// 		}

	// 		res = { isSuccess: true, data: list };
	// 	});

	// 	return res;
	// },
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).showDialog,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).showDialog) = $event)),
    title: _unref(state).title,
    style: {"width":"720px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: __props.loading,
        onClick: events.onSave
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: __props.loading,
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).showDialog = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
          ref_key: "payPlanFormRef",
          ref: payPlanFormRef,
          model: planSchema.value,
          rules: _unref(state).rules,
          "label-width": "150px",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $props.ctAmounts,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.ctAmounts) = $event)),
                  disabled: "",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款项名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: planSchema.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((planSchema.value.name) = $event)),
                  type: "text",
                  placeholder: "请输入款项名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款项条件",
              prop: "pay_condition"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: planSchema.value.pay_condition,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((planSchema.value.pay_condition) = $event)),
                  type: "text",
                  placeholder: "请输入款项条件"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "款项比例" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: planSchema.value.scale,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((planSchema.value.scale) = $event)),
                  precision: 2,
                  step: 10,
                  max: _unref(state).config.maxScalc,
                  disabled: _unref(state).disabledAmt,
                  onInput: events.onScalceChange,
                  style: {"width":"200px"}
                }, null, 8, ["modelValue", "max", "disabled", "onInput"]),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "款项金额",
              prop: "amount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: planSchema.value.amount,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((planSchema.value.amount) = $event)),
                  precision: 2,
                  step: 1,
                  max: _unref(state).config.maxAmount,
                  disabled: _unref(state).disabledAmt,
                  onInput: events.onAmountChange,
                  style: {"width":"200px"}
                }, null, 8, ["modelValue", "max", "disabled", "onInput"]),
                _createElementVNode("span", _hoisted_3, " 可设最大金额：" + _toDisplayString(_unref(state).config.maxAmount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "计划付款日期",
              prop: "pay_date"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: planSchema.value.pay_date,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((planSchema.value.pay_date) = $event)),
                  type: "date",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择计划付款日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: "4",
                  modelValue: planSchema.value.remark,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((planSchema.value.remark) = $event)),
                  placeholder: "请输入款项备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [_directive_loading, _unref(state).loading]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})